import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'gold' | 'navy' | 'outline';
  size?: 'sm' | 'lg';
  arrow?: boolean;
  href?: string;
  target?: '_blank';
  rel?: string;
  onClick?: () => void;
  ariaLabel?: string;
};
export function Button({
  children,
  className = '',
  variant = 'gold',
  size = 'lg',
  arrow = false,
  href,
  target,
  rel,
  onClick,
  ariaLabel
}: ButtonProps) {
  const styles = {
    gold: 'bg-gold text-navy shadow-[0_10px_24px_rgba(217,164,65,.24)] hover:bg-[#EAC369]',
    navy: 'bg-navy text-ink shadow-[0_10px_24px_rgba(0,0,0,.3)] hover:bg-[#173651]',
    outline: 'border-2 border-teal bg-transparent text-teal hover:bg-teal hover:text-navy'
  };
  const sizes = {
    sm: 'px-4 py-2.5 text-sm',
    lg: 'px-6 py-4 text-sm sm:px-8 sm:text-base'
  };
  const classes = `inline-flex items-center justify-center gap-2 rounded-xl font-extrabold transition-colors duration-200 focus:outline-none focus-visible:ring-4 focus-visible:ring-teal/45 ${styles[variant]} ${sizes[size]} ${className}`;
  if (href) return <a href={href} target={target} rel={rel} className={classes} aria-label={ariaLabel} data-id="element-266" data-mp="eqxxem6s6vez">{children}{arrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-267" data-mp="toi01mg7gehz" />}</a>;
  return <button type="button" onClick={onClick} className={classes} aria-label={ariaLabel} data-id="element-268" data-mp="onki9az3xmh0">{children}{arrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-269" data-mp="12mtmdca1gq4m" />}</button>;
}